import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      errorCount: 0,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error("Error caught by ErrorBoundary:", error, errorInfo);

    // Increment error count
    this.setState((prevState) => ({
      error,
      errorInfo,
      errorCount: prevState.errorCount + 1,
    }));

    // Report error to error tracking service (e.g., Sentry, LogRocket)
    if (window.errorReportingService) {
      window.errorReportingService.captureException(error, { errorInfo });
    }
  }

  resetError = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col md={8} className="text-center">
              <div className="error-boundary-container">
                <h1 className="text-danger mb-4">Oops! Something went wrong</h1>
                <p className="lead mb-4">
                  We encountered an unexpected error. Please try refreshing the
                  page.
                </p>

                {process.env.NODE_ENV === "development" && (
                  <details
                    className="mb-4 text-start bg-light p-3 rounded"
                    style={{ overflow: "auto" }}
                  >
                    <summary className="cursor-pointer mb-2">
                      Error Details (Development Only)
                    </summary>
                    <pre className="mb-0" style={{ fontSize: "0.85rem" }}>
                      {this.state.error && this.state.error.toString()}
                      {"\n\n"}
                      {this.state.errorInfo &&
                        this.state.errorInfo.componentStack}
                    </pre>
                  </details>
                )}

                <div className="mt-4">
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={this.resetError}
                    className="me-2"
                  >
                    Try Again
                  </Button>
                  <Button
                    variant="secondary"
                    size="lg"
                    onClick={() => window.location.href = "/"}
                  >
                    Go Home
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
